import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "actions" }
const _hoisted_2 = ["disabled"]

import { ref, computed } from 'vue';
import { useGameStore } from '@/stores/gameStore';


export default /*@__PURE__*/_defineComponent({
  __name: 'ApiKeyModal',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const gameStore = useGameStore();
const key = ref('');

const isValid = computed(() => key.value.length > 20);

const save = async () => {
    if (isValid.value) {
        await gameStore.setApiKey(key.value);
        emit('close');
    }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "modal-overlay",
    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _createElementVNode("div", {
      class: "modal-content",
      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
    }, [
      _cache[4] || (_cache[4] = _createElementVNode("h3", null, "🔑 API Ключ (Dev)", -1)),
      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "desc" }, " Введите Gemini API Key для этой сессии. Он будет использован только для этой комнаты. ", -1)),
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((key).value = $event)),
        type: "password",
        class: "form-input",
        placeholder: "Вставьте ключ сюда..."
      }, null, 512), [
        [_vModelText, key.value]
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("button", {
          class: "btn",
          onClick: save,
          disabled: !isValid.value
        }, "Сохранить", 8, _hoisted_2),
        _createElementVNode("button", {
          class: "btn btn-outline",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
        }, "Отмена")
      ])
    ])
  ]))
}
}

})